module.exports = __webpack_public_path__ + "img/BS21.05630e3b.svg";